import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import data from './userdata.json';
import './App.css';
var Parser = require('html-react-parser')




class Login extends Component{
  constructor(props){
    super(props)
    
    this.state={
      username:'',
      password:'',
      errors: ''
    }
    
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUsernameChange = this.handleUsernameChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);

  }

  handleUsernameChange(event) {                
    this.setState({username: event.target.value});
  }

  handlePasswordChange(event) {                
      this.setState({password: event.target.value});
  }

  handleSubmit(event) { 
    event.preventDefault();
    var self = this;
    if(this.state.username==="miller" && this.state.password ==="password1"){
      self.props.history.push("/user/miller")
    }else if(this.state.username==="tomaev" && this.state.password ==="password2"){
      self.props.history.push("/user/tomaev")    
    }else if(this.state.username==="suleymanova" && this.state.password ==="password3"){
      self.props.history.push("/user/suleymanova")    
    }else if(this.state.username==="giyazov" && this.state.password ==="password4"){
      self.props.history.push("/user/giyazov")    
    }else if(this.state.username==="petrova" && this.state.password ==="password5"){
      self.props.history.push("/user/petrova")    
    }else if(this.state.username==="admin" && this.state.password ==="admin"){
      self.props.history.push("/admin")
    }else{
      this.setState({
        errors: "Неправилный логин/пароль."
      });
    }
  }

  render(){
    return(
        <div className="row justify-content-center">
            <form className=" col-6" id="loginForm">
                <div className="form-group">
                    <label htmlFor="username">Пользователь</label>
                    <input 
                        type="text" 
                        name="username" 
                        placeholder="Пользователь" 
                        id="username" 
                        className="form-control" 
                        value={this.state.username}
                        onChange={this.handleUsernameChange} 
                         />
                </div>
                <div className="form-group">
                    <label htmlFor="password">Пароль</label>
                    <input 
                        type="password" 
                        name="password" 
                        placeholder="Пароль" 
                        id="password" 
                        className="form-control" 
                        value={this.state.password}
                        onChange={this.handlePasswordChange} 
                        />
                </div>
                <div className="form-group">
                    <button className="btn-light btn btn-submit" onClick = {this.handleSubmit}>
                        <i className="fas fa-key"></i> Войти
                    </button>
                    <p className="float-right text-danger">{this.state.errors}</p>
                </div>
            
            </form>    
        </div>            
            
        )
}

}

class AdminSidebar extends Component{
  constructor(props){
    super(props)
    
    this.state={
      username:'user'      
    }
    
  }

  render(){
    /*<a href="/admin/documents/list" className="list-group-item">Общие документы</a>*/
    return(
      <div className="list-group" id='adminSidebar'>
        <a href="/admin" className="list-group-item">Список аспирантов</a>
        
      </div>
    )
  }
}

class Admin extends Component{
  constructor(props){
    super(props)
    
    this.state={
      username:'user'      
    }
    
  }

  render(){
    return(
      <div>
        <h4>Аспирантов</h4>
        <div className="list-group">
          <a href="/admin/ivanov" className="list-group-item-action list-group-item">Иванов Иван Иванович</a>
          <a href="/admin/ivanov" className="list-group-item-action list-group-item">Иванов Иван Иванович</a>
          <a href="/admin/ivanov" className="list-group-item-action list-group-item">Иванов Иван Иванович</a>
          <a href="/admin/ivanov" className="list-group-item-action list-group-item">Иванов Иван Иванович</a>
          <a href="/admin/ivanov" className="list-group-item-action list-group-item">Иванов Иван Иванович</a>
          <a href="/admin/ivanov" className="list-group-item-action list-group-item">Иванов Иван Иванович</a>
        </div>       
      </div>
    )}
}

class DocumentList extends Component{
  constructor(props){
    super(props)
    
    this.state={         
    }
    
  }

  render(){
    return(
    <div>
      <h4>Общие Документы</h4>

      <h5>Загрузить новый файл</h5>
      <form action="">
      <input type="file" name='file'/>
      </form>

      <hr/>

      <div className="list-group">
        <a href="" className="list-group-item">Документ</a>
        <a href="" className="list-group-item">Документ</a>
        <a href="" className="list-group-item">Документ</a>
        <a href="" className="list-group-item">Документ</a>
      </div>
    </div>
    )
  }
}

class UserPanel extends Component{
  constructor(props){
    super(props)
    
    this.state={   
      user: this.props.match.params.user   
    }
    
  }

  render(){
    return(
    <div>
      <h4>Документы - {this.state.user}</h4>
      <ul className="list-group">
        <li className="list-group-item"><a href="" className="align-middle">Ведомость результатов</a><LoadButton /></li>
        <li className="list-group-item"><a href="" className="align-middle">Протоколы сдачи кандидатских экзаменов</a> <LoadButton /></li>
      </ul>
    </div>
    )
  }
}

class LoadButton extends Component{
  render(){
    return( 
      
      <button className="btn btn-light float-right disabled" type="file">Загрузить</button> 
      
    )
  }
}

class Cabinet extends Component{
  constructor(props){
    super(props)
    let plannkr = Parser('План диссертации ')
    let dnevnik = Parser('Дневник и отчет по педагогической практике')
    let resultatov = Parser('Список апробации НКР (Д)')
    let doklad = Parser('Текст научного доклада по результатам НКР работа (диссертации)')
    let publications = Parser('Список публикаций')
    
    let username = this.props.match.params.username
    let files = data[username].files    
    
    if(files.plannkr !==''){
      plannkr = Parser('<a href="/data/'+username+'/'+files.plannkr+'" target="_blank">План диссертации</a> ')   
    }
    if(files.dnevnik !==''){
      dnevnik = Parser('<a href="/data/'+username+'/'+files.dnevnik+'" target="_blank">Дневник и отчет по педагогической практике</a>')
    }
    if(files.resultatov !==''){
      resultatov = Parser(' <a href="/data/'+username+'/'+files.resultatov+'" target="_blank"> Список апробации НКР (Д) </a>'    )  
    }
    if(files.doklad !==''){      
      doklad = Parser(' <a href="/data/'+username+'/'+files.doklad+'" target="_blank">Текст научного доклада по результатам НКР работа (диссертации)</a>'    )  
    }
    if(files.publications !==''){      
      publications = Parser(' <a href="/data/'+username+'/'+files.publications+'" target="_blank">Список публикаций</a>'    )  
    }
    this.state={
      username:username,         
      plannkr: plannkr,
      dnevnik: dnevnik,
      resultatov: resultatov,
      doklad:doklad,
      publications:publications
    }
    
      
  }
    
  render(){
    return(
      <div className="col-12">
        <h2 className="pageTitle">ПОРТФОЛИО АСПИРАНТА</h2>
        <div className="row">
          <div className="col">
            <div className="row ">
              <span className="col-5">Ф.И.О.:</span>
              <span className="userdata">{ data[this.state.username].fullname }</span>
            </div>
            <div className="row ">
              <span className="col-5">Приказ о зачислении:</span>
              <span className="userdata">{ data[this.state.username].prikaz }</span>
            </div>
            <div className="row ">
              <span className="col-5">Сроки обучения:</span>
              <span className="userdata">3 года </span>
            </div>
            <div className="row ">
              <span className="col-5">Форма обучения:</span>
              <span className="userdata">Очная </span>
            </div>          
            <div className="row ">
              <span className="col-5">Направление:</span>
              <span className="userdata">30.06.01 Экономика  </span>
            </div>          
            <div className="row ">
              <span className="col-5">Профиль:</span>
              <span className="userdata">Экономическая теория</span>
            </div>
          </div>
          <div className="col-2">
            <img src="/missing.png" alt="avatar" className="maxheight200"/>
          </div>
        </div>
          <hr/>
          <div className="row ">
            <span className="col-4">Лаборатория:</span>
            <span className="userdata col-8 ">{data[this.state.username].lab }</span>
          </div>
          <div className="row ">
            <span className="col-4">Научный руководитель:</span>
            <span className="userdata col-8">{data[this.state.username].rukovoditel }</span>
          </div>
          <div className="row ">
            <span className="col-4">Тема НКР (Д) :</span>
            <span className="userdata col-8">{data[this.state.username].tema }</span>
          </div>
          <div className="row ">
            <span className="col-4">Дата утверждения темы и номер протокола Ученого Совета:</span>
            <span className="userdata col-8 align-baseline">«25» декабря 2017 г. Протокол № 4</span>
          </div>            
          <hr/>
          <div className="row ">
            <span className="col-4">E-mail  </span>
            <span className="userdata col-8">{data[this.state.username].email }</span>
          </div>      
          <div className="row ">
            <span className="col-4">Телефон</span>
            <span className="userdata col-8">{data[this.state.username].phone } </span>
          </div>   
          <hr/>
          <h4>Прикрепленные файлы:</h4>
          <div className="row ">
            <span className="col-sm-3">Образовательный процесс</span>
            <ul className="list-group col-sm-9">
              <li className="list-group-item"><a href={"/data/"+this.state.username+"/"+ data[this.state.username].files.vedomost }   target="_blank">Сводная ведомость </a></li>
              <li className="list-group-item"><a href="" data-toggle="modal" data-target="#protocolsModal">Протоколы сдачи кандидатских экзаменов</a></li>
              
              <li className="list-group-item"  >
              
              { this.state.dnevnik } <LoadButton/> </li>
            </ul>
            
          </div>  
          <hr/>
          <div className="row ">
            <span className="col-sm-3">Научная работа</span>
            <ul className="list-group col-sm-9">
              
              <li className="list-group-item"  >{this.state.plannkr} <LoadButton /></li>
              <li className="list-group-item">Ежегодные отчеты по научно-исследовательской работе  <LoadButton /></li>
              <li className="list-group-item">{ this.state.publications }  <LoadButton /></li>
              <li className="list-group-item">{  this.state.resultatov } <LoadButton /></li>
            </ul>
          </div>  
          <hr/>
          <div className="row ">
            <span className="col-sm-3">Научно квалификационная работа</span>
            <ul className="list-group col-sm-9">              
              <li className="list-group-item">{ this.state.doklad }</li>
              <li className="list-group-item">Отзыв научного руководителя </li>
              <li className="list-group-item">Рецензии на научный доклад   </li>              
            </ul>
          </div> 
      </div>
    );
  }
}

class Modal extends Component{  

  render(){
    let username = this.props.match.params.username
    let prots = data[username].files.protokols
    let dats = Object.keys(prots)
    
    let protokolLinks = dats.map((prot, index) =>
      
      <a target="_blank" className="list-group-item" href={"/data/"+username+"/"+prots[index+1]} key={index}>  { prots[index+1] } </a>
      
    );

    return (
    <div className="modal fade" id="protocolsModal" tabIndex="1" role="dialog" aria-labelledby="protocolsModalLabel" aria-hidden="true">
    <div className="modal-dialog" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">Протоколы сдачи кандидатских экзаменов</h5>
          <button type="button" className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="list-group">
          { protokolLinks }         
          </div>                  
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" data-dismiss="modal">Закрыть</button>                    
        </div>
      </div>
    </div>
  </div>
  );
  }
}

class App extends Component {
  render() {
    /*
    var loggedin = false;
    if( !== "/login"){
      loggedin = true;
    }
    */
   let loggedin = false;
    return (
      <div className="">
        <nav className = "navbar navbar-expand-sm sticky-top navbar-dark bg-dark" >         
          <img src='/logo.png' alt="logo" />
          <span>Аспирантура</span> 

          {loggedin ? <a href="/login" className="btn btn-link float-right">Logout</a> : ''}
        </nav>
        <div className ="container-fluid">
            <Route 
                exact
                path="/" 
                render={(props) => <Login {...props} /> }
            />
            <Route 
                path="/user/:username" 
                render={(props) => (
                  <div className="row">
                    {/*}
                    <div className='sidebar col-3 order-last order-sm-first'>
                    Sidebar
                    </div>
                    */}
                    <div className='col-md-12 col-lg-8 mx-auto justify-content-center order-first order-sm-last ' id="main">
                      <Cabinet {...props} />
                    </div>
                      <Modal {...props} />
                  </div>
                )}
            />
            <Route 
                exact
                path="/admin" 
                render={(props) => (
                  <div className="row">
                    <div className='sidebar col-3 order-last order-sm-first'>
                      <AdminSidebar {...props} />
                    </div>
                    <div className='col-9 order-first order-sm-last' id="main">
                      <Admin {...props} />
                    </div>
                  </div>
                )}
            />
            <Route 
                exact
                path="/admin/:user" 
                render={(props) => (
                  <div className="row">
                    <div className='sidebar col-3 order-last order-sm-first'>
                      <AdminSidebar {...props} />
                    </div>
                    <div className='col-9 order-first order-sm-last' id="main">
                      <UserPanel {...props} />
                    </div>
                  </div>
                )}
            />
            <Route 
                exact
                path="/admin/documents/list" 
                render={(props) => (
                  <div className="row">
                    <div className='sidebar col-3 order-last order-sm-first'>
                      <AdminSidebar {...props} />
                    </div>
                    <div className='col-9 order-first order-sm-last' id="main">
                      <DocumentList {...props} />
                    </div>
                  </div>
                )}
            />
          
        </div>
        
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js